var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriluftsbadSvoemmebad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.382,9.98V8.953H9.269V10.01a.647.647,0,0,0,.3.064.628.628,0,0,0,.38-.111V5.148c0-.424.27-.783.589-.783s.59.359.59.783a.341.341,0,0,0,.682,0A1.38,1.38,0,0,0,10.54,3.683,1.38,1.38,0,0,0,9.269,5.148V6.306H6.382V5.148c0-.424.27-.783.59-.783s.59.359.59.783a.341.341,0,1,0,.681,0A1.38,1.38,0,0,0,6.972,3.683,1.381,1.381,0,0,0,5.7,5.148V10a.647.647,0,0,0,.328.076A.631.631,0,0,0,6.382,9.98Zm0-2.993H9.269V8.272H6.382Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.111,10.654a.879.879,0,0,1-.661-.3,1.541,1.541,0,0,0-2.218,0,.874.874,0,0,1-1.322,0,1.545,1.545,0,0,0-2.22,0,.876.876,0,0,1-1.325,0,1.548,1.548,0,0,0-2.222,0,.879.879,0,0,1-.663.3.341.341,0,1,0,0,.681,1.542,1.542,0,0,0,1.111-.47.877.877,0,0,1,1.326,0,1.547,1.547,0,0,0,2.221,0,.874.874,0,0,1,1.323,0,1.545,1.545,0,0,0,2.219,0,.872.872,0,0,1,1.322,0,1.537,1.537,0,0,0,1.109.47.341.341,0,0,0,0-.681Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriluftsbadSvoemmebad);
export default __webpack_public_path__ + "static/media/FRILUFTSBAD-SVOEMMEBAD.08c67cb61f0702c44230e1cf9c8e93dc.svg";
export { ForwardRef as ReactComponent };